import styled from 'styled-components';
import { TypographyWeight, Weight } from './consts';

const { EXTRA_BOLD, BOLD, SEMI_BOLD, REGULAR, LIGHT } = TypographyWeight;

const getWeight = (weight, weights) => {
  if (typeof weight === 'number' && weights.some(w => Weight[w] === weight)) return weight;
  return weights.includes(weight) ? Weight[weight] : Weight[weights[weights.length - 1]];
};

export const H1 = styled.h1.attrs({ className: 'dsc-h1' })`
  text-transform: ${({ $textTransform }) => $textTransform || 'var(--title-text-transform)'};
  font-size: 20px;
  letter-spacing: 0.8px;
  font-weight: ${({ $weight }) => getWeight($weight, [SEMI_BOLD, REGULAR])};
  color: ${({ $color }) => $color};
  margin: 0;
`;

export const H2 = styled.h2.attrs({ className: 'dsc-h2' })`
  text-transform: ${({ $textTransform }) => $textTransform || 'var(--title-text-transform)'};
  font-size: 16px;
  letter-spacing: 0.5px;
  font-weight: ${({ $weight }) => getWeight($weight, [BOLD, SEMI_BOLD])};
  color: ${({ $color }) => $color};
  margin: 0;
`;

export const H3 = styled.h3.attrs({ className: 'dsc-h3' })`
  text-transform: ${({ $textTransform }) => $textTransform || 'var(--title-text-transform)'};
  font-size: 12px;
  letter-spacing: 0.5px;
  font-weight: ${({ $weight }) => getWeight($weight, [BOLD, SEMI_BOLD, REGULAR])};
  color: ${({ $color }) => $color};
  margin: 0;
`;

export const H4 = styled.h4.attrs({ className: 'dsc-h4' })`
  text-transform: ${({ $textTransform }) => $textTransform || 'var(--title-text-transform)'};
  font-size: 10px;
  letter-spacing: 0.5px;
  font-weight: ${({ $weight }) => getWeight($weight, [BOLD, REGULAR])};
  color: ${({ $color }) => $color};
  margin: 0;
`;

export const B1 = styled.div.attrs({ className: 'dsc-b1' })`
  font-size: 14px;
  letter-spacing: 0.5px;
  font-weight: ${({ $weight }) => getWeight($weight, [BOLD, SEMI_BOLD, REGULAR])};
  color: ${({ $color }) => $color};
`;

export const B1Condensed = styled.div.attrs({ className: 'dsc-b1c' })`
  font-size: 14px;
  letter-spacing: 0.2px;
  font-weight: ${Weight.REGULAR};
  color: ${({ $color }) => $color};
`;

export const B2 = styled.div.attrs({ className: 'dsc-b2' })`
  font-size: 12px;
  letter-spacing: 0.6px;
  font-weight: ${({ $weight }) => getWeight($weight, [EXTRA_BOLD, BOLD])};
  color: ${({ $color }) => $color};
`;

export const B2Condensed = styled.div.attrs({ className: 'dsc-b2c' })`
  font-size: 12px;
  letter-spacing: 0.3px;
  font-weight: ${({ $weight }) => getWeight($weight, [SEMI_BOLD, REGULAR, LIGHT])};
  color: ${({ $color }) => $color};
`;
